import { render, staticRenderFns } from "./ImportPortfolioModal.vue?vue&type=template&id=0a60e0a7&scoped=true&"
import script from "./ImportPortfolioModal.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportPortfolioModal.vue?vue&type=style&index=0&id=0a60e0a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60e0a7",
  null
  
)

export default component.exports